<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/dewas-list">Daftar Dewan Pengawas</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Tambah Dewan Pengawas
        </li>
      </ol>
    </nav>
    <div class="content-block">
      <div class="col"><h5>Tambah Dewan Pengawas</h5></div>
    </div>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxTabPanel
          id="tabPanel"
          ref="myTabPanel"
          v-model:selected-index="tabPanelIndex"
          :data-source="tabData"
          :animation-enabled="true"
          item-title-template="title"
          item-template="currentTemplate"
        >
          <template #title="{ data: item }">
            <span class="tab-panel-title">{{ item.text }}</span>
          </template>

          <template #t1>
            <div
              class="editors"
              style="padding-top: 25px"
              v-if="dewasDataSource"
            >
              <div class="row row-cols-1 row-cols-md-2">
                <div class="col">
                  <div class="editors-container">
                    <div class="left">
                      <DxTextBox
                        :styling-mode="stylingMode"
                        :label-mode="labelMode"
                        width="100%"
                        label="Nama"
                        placeholder="Nama"
                        v-model="dewasDataSource.nama"
                      >
                        <DxValidator>
                          <DxRequiredRule />
                        </DxValidator>
                      </DxTextBox>

                      <DxTextBox
                        :styling-mode="stylingMode"
                        :label-mode="labelMode"
                        width="100%"
                        label="Alamat"
                        placeholder="Alamat"
                        v-model="dewasDataSource.alamat"
                      >
                      </DxTextBox>

                      <DxTextBox
                        :styling-mode="stylingMode"
                        :label-mode="labelMode"
                        width="100%"
                        label="No. Telp"
                        placeholder="No. Telp"
                        v-model="dewasDataSource.telp"
                      >
                      </DxTextBox>
                      <DxSelectBox
                        :dataSource="commonStore.agamaStore"
                        valueExpr="id"
                        displayExpr="nama"
                        :styling-mode="stylingMode"
                        :label-mode="labelMode"
                        width="100%"
                        placeholder="Agama"
                        label="Agama"
                        v-model="dewasDataSource.agama_id"
                      >
                      </DxSelectBox>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="editors-container">
                    <div class="left">
                      <DxTextBox
                        :styling-mode="stylingMode"
                        :label-mode="labelMode"
                        width="100%"
                        label="Tempat lahir"
                        placeholder="Tempat lahir"
                        v-model="dewasDataSource.tempat_lahir"
                      >
                      </DxTextBox>
                      <DxDateBox
                        :styling-mode="stylingMode"
                        :label-mode="labelMode"
                        :display-format="'dd/MM/yyyy'"
                        width="100%"
                        placeholder="Tgl lahir"
                        label="Tgl lahir"
                        v-model="dewasDataSource.tgl_lahir"
                      >
                        <DxValidator>
                          <DxRequiredRule />
                        </DxValidator>
                      </DxDateBox>

                      <DxSelectBox
                        :dataSource="jenisKelaminSource"
                        valueExpr="val"
                        displayExpr="nama"
                        :styling-mode="stylingMode"
                        :label-mode="labelMode"
                        width="100%"
                        placeholder="Jenis Kelamin"
                        label="Jenis Kelamin"
                        v-model="dewasDataSource.jenis_kelamin"
                      >
                        <DxValidator>
                          <DxRequiredRule />
                        </DxValidator>
                      </DxSelectBox>
                      <DxSelectBox
                        :dataSource="commonStore.statusIsDewasStore"
                        valueExpr="val"
                        displayExpr="nama"
                        :searchEnabled="true"
                        searchExpr="nama"
                        search-mode="startswith"
                        :styling-mode="stylingMode"
                        :label-mode="labelMode"
                        width="100%"
                        placeholder="Sebagai"
                        label="Sebagai"
                        v-model="dewasDataSource.is_dewas"
                      >
                      </DxSelectBox>
                    </div>
                  </div>
                </div>
              </div>

              <div class="center">
                <label for="fileUploader">Foto profil:</label>
                <DxFileUploader
                  ref="fileUploader"
                  accept="image/*"
                  upload-mode="useForm"
                  name="files"
                  multiple="false"
                  @value-changed="handleFileUploader($event)"
                >
                </DxFileUploader>
              </div>
              <div class="center">
                <DxButton
                  v-if="can('pegawai-create')"
                  @click="validateClick('t1', $event)"
                  icon="chevrondoubleright"
                  text="Selanjutnya"
                  styling-mode="outlined"
                  type="default"
                  class="validate"
                  style="float: right"
                  :icon-position="'right'"
                />
              </div>
            </div>
          </template>

          <template #t2>
            <DxDataGrid
              id="dataGridPph"
              :data-source="pphDataSource"
              :focused-row-index="0"
              :show-borders="true"
              :show-column-lines="false"
              :focused-row-enabled="true"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              :allow-column-reordering="true"
              key-expr="id"
              @row-inserting="onRowInserting"
              @row-updating="onRowUpdating"
            >
              <dx-paging :page-size="10" />
              <dx-pager :show-page-size-selector="true" :show-info="true" />
              <dx-filter-row :visible="true" />

              <DxExport :enabled="true" :allow-export-selected-data="true" />
              <!-- <DxSelection :mode="multiple" :showCheckBoxesMode="always" /> -->

              <DxToolbar>
                <DxItem name="groupPanel" />

                <DxItem name="addRowButton" show-text="always" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
                <DxItem name="searchPanel" />
              </DxToolbar>

              <DxEditing
                :allow-updating="true"
                :allow-adding="true"
                :allow-deleting="true"
                :mode="dxEditingMode"
                :new-row-position="bottom"
              />
              <DxSorting mode="multiple" />
              <DxColumn
                data-field="status_hitung"
                caption="Status Hitung PPH"
                :allowHeaderFiltering="true"
                :header-filter="{
                  dataSource: commonStore.statusSource,
                }"
                :dataType="'boolean'"
                cell-template="templateStatus"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="val"
                  :data-source="commonStore.statusStore"
                />
              </DxColumn>
              <DxColumn
                data-field="tgl"
                caption="Tgl"
                data-type="date"
                :display-format="'dd/MM/yyyy'"
                :format="'dd/MM/yyyy'"
                :allowHeaderFiltering="false"
                sort-order="asc"
              >
                <DxRequiredRuleDataGrid />
              </DxColumn>

              <template #templateStatus="{ data }">
                <StatusTemplate :value="data.value" />
              </template>

              <DxColumn
                data-field="ptkp"
                caption="PTKP"
                :allowHeaderFiltering="true"
                :header-filter="{
                  dataSource: commonStore.statusPtkpSource,
                }"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="nama"
                  :data-source="commonStore.statusPtkpStore"
                />
                <DxRequiredRuleDataGrid />
              </DxColumn>

              <DxColumn
                data-field="ter"
                caption="TER PPH 21 (%)"
                :allowHeaderFiltering="false"
              />
            </DxDataGrid>
            <div style="padding-top: 20px">
              <DxButton
                @click="prevClick(0)"
                icon="chevrondoubleleft"
                text="Sebelumnya"
                styling-mode="outlined"
                type="default"
                class="validate"
                style="float: left"
              />

              <DxButton
                @click="validateClick('t2', $event)"
                icon="chevrondoubleright"
                text="Selanjutnya"
                styling-mode="outlined"
                type="default"
                class="validate"
                style="float: right"
                :icon-position="'right'"
              />
            </div>
          </template>

          <template #t3>
            <DxDataGrid
              ref="refDataGridPekerjaan"
              id="dataGridPekerjaan"
              :data-source="pekerjaanDataSource"
              :focused-row-index="0"
              :show-borders="true"
              :show-column-lines="false"
              :focused-row-enabled="true"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              :allow-column-reordering="true"
            >
              <dx-paging :page-size="numberingPageSize" />
              <dx-pager :show-page-size-selector="true" :show-info="true" />
              <dx-filter-row :visible="true" />

              <DxExport :enabled="true" :allow-export-selected-data="true" />
              <!-- <DxSelection mode="multiple" /> -->

              <DxToolbar>
                <DxItem name="groupPanel" />

                <DxItem name="addRowButton" show-text="always" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
                <DxItem name="searchPanel" />
              </DxToolbar>

              <DxEditing
                :allow-updating="true"
                :allow-adding="true"
                :allow-deleting="true"
                :mode="dxEditingMode"
                :new-row-position="bottom"
              />

              <dx-column
                data-field="jabatan_id"
                caption="Jabatan"
                data-type="number"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="id"
                  :data-source="commonStore.jabatanDewasStore"
                />
                <DxRequiredRuleDataGrid />
              </dx-column>

              <dx-column
                data-field="tgl_mulai_bekerja"
                caption="Tgl Mulai"
                data-type="date"
                :display-format="'dd/MM/yyyy'"
                :format="'dd/MM/yyyy'"
                editor-type="dxDateBox"
              >
                <DxRequiredRuleDataGrid />
              </dx-column>
              <dx-column
                data-field="tgl_akhir_bekerja"
                caption="Tgl Akhir"
                data-type="date"
                :display-format="'dd/MM/yyyy'"
                :format="'dd/MM/yyyy'"
                editor-type="dxDateBox"
              >
              </dx-column>
            </DxDataGrid>
            <div style="padding-top: 20px">
              <DxButton
                icon="chevrondoubleleft"
                @click="prevClick(1)"
                text="Sebelumnya"
                styling-mode="outlined"
                type="default"
                class="validate"
                style="float: left"
              />
              <!-- <DxButton
                @click="validateClick('t10', $event)"
                icon="save"
                text="Simpan Data"
                type="default"
                class="validate"
                style="float: right"
              /> -->

              <DxButton
                @click="validateClick('t3', $event)"
                icon="save"
                text="Simpan Data"
                type="default"
                class="validate"
                style="float: right"
                :icon-position="'right'"
              />
            </div>
          </template>
        </DxTabPanel>
      </div>
    </div>

    <div class="content-block">
      <div class="row">
        <!-- <div class="editors"> -->
        <div class="editors-container">
          <div class="col" style="padding-left: 10px">
            <DxSelectBox
              ref="selectDxediting"
              :dataSource="dxEditingSource"
              valueExpr="val"
              displayExpr="nama"
              width="10%"
              label="Editing Mode"
              placeholder="Editing Mode"
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              :searchEnabled="true"
              v-model="dxEditingMode"
            >
            </DxSelectBox>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import auth from "../auth";
import { useCommonStore } from "@/stores/utility/common-store2";
import { usePegawaiListStore } from "@/stores/views/pegawai-list-store";
import api from "@/api";
import can from "@/haspermission";
import StatusTemplate from "./StatusTemplate.vue";
import { API_BASE_URL } from "@/global-constants";
import { DxFileUploader } from "devextreme-vue/file-uploader";
import router from "@/router";
import { DateTime } from "luxon";
import DxTabPanel from "devextreme-vue/tab-panel";
import DxSelectBox from "devextreme-vue/select-box";
import DxTextBox from "devextreme-vue/text-box";
import axios from "axios";
// import DxTextArea from "devextreme-vue/text-area";
// import DxTagBox from "devextreme-vue/tag-box";
import DxDateBox from "devextreme-vue/date-box";
import DxButton from "devextreme-vue/button";

import { DxValidator, DxRequiredRule } from "devextreme-vue/validator";
import notify from "devextreme/ui/notify";
import service from "./pegawai-add-data.js";
import _ from "lodash";
import DxDataGrid, {
  DxColumn,
  DxFilterRow,
  DxPager,
  DxPaging,
  DxEditing,

  // DxSelection,
  DxExport,
  DxToolbar,
  DxLookup,
  DxItem,
  DxSorting,
  DxRequiredRule as DxRequiredRuleDataGrid,
} from "devextreme-vue/data-grid";
import DataSource from "devextreme/data/data_source";

// const dataGridRefKey = "myDataGrid";
export default {
  components: {
    DxSelectBox,
    DxTextBox,
    // DxTextArea,
    // DxTagBox,
    DxDateBox,
    DxButton,
    DxValidator,
    DxTabPanel,
    DxDataGrid,
    DxColumn,
    DxFilterRow,
    DxPager,
    DxPaging,
    DxEditing,

    // DxSelection,
    DxExport,
    DxToolbar,
    DxLookup,
    DxItem,
    DxRequiredRule,
    DxRequiredRuleDataGrid,
    DxSorting,
    DxFileUploader,
    StatusTemplate,
  },
  setup() {
    const pegawaiListStore = usePegawaiListStore();
    const commonStore = useCommonStore();
    // const statusAktifStore = useStatusAktifStore();
    return {
      commonStore,
      pegawaiListStore,
      // statusAktifStore,
    };
    // const picture = "images/employees/06.png";
    // const imageUrl = `https://js.devexpress.com/Demos/WidgetsGallery/JSDemos/${picture}`;
  },

  data() {
    return {
      dxEditingMode: "popup", //popup or row
      dxEditingSource: [
        { val: "row", nama: "Baris" },
        { val: "popup", nama: "Form popup" },
      ],
      columnEditorOptions: { enableThreeStateBehavior: false },
      router: router,
      ptkpSource: [
        { val: null },
        { val: "TK" },
        { val: "K0" },
        { val: "K1" },
        { val: "K2" },
        { val: "K3" },
      ],
      naikPangkatTglBeforeEdit: null,
      naikPangkatTglMulaiBekerja: "",
      patternDMY: /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-[0-9]{4}$/,
      editorOptions: { mask: "99-99-9999", useMaskBehavior: true },
      pattern: /^\(\d{3}\) \d{3}-\d{4}$/i,
      patternTahun: /^\d{4}$/i,
      patternNumeric: /^\d+(?:[.,]\d+)?$/,

      pendidikanDataSource: new DataSource({
        store: {
          type: "array",
          key: "key",
          data: [],
        },
      }),

      peringatanDataSource: new DataSource({
        store: {
          type: "array",
          key: "key",
          data: [],
        },
      }),

      penghargaanDataSource: new DataSource({
        store: {
          type: "array",
          key: "key",
          data: [],
        },
      }),

      naikPangkatDataSource: new DataSource({
        store: {
          type: "array",
          key: "key",
          data: [],
        },
      }),

      KGBDataSource: new DataSource({
        store: {
          type: "array",
          key: "key",
          data: [],
        },
      }),
      // naikPangkatDataSource: [
      //   {
      //     key: 1,
      //     masa_kerja: 7,
      //     ket: "hello",
      //   },
      // ],
      transportDataSource: new DataSource({
        store: {
          type: "array",
          key: "key",
          data: [],
        },
      }),
      pekerjaanDataSource: new DataSource({
        store: {
          type: "array",
          key: "key",
          data: [
            // {
            //   key: 1,
            //   pegawai_status_id: 2,
            //   jabatan_id: 12,
            //   cabang_id: 1,
            //   tgl_mulai_bekerja: "2023-04-03",
            // },
          ],
        },
      }),

      keluargaDataSource: new DataSource({
        store: {
          type: "array",
          key: "key",
          data: [],
        },
      }),

      pphDataSource: new DataSource({
        store: {
          type: "array",
          key: "key",
          data: [],
        },
      }),

      tabPanelIndex: 0,

      // pegawaiIdSource: null,

      jenisKelaminSource: [
        { val: "L", nama: "Laki-Laki" },
        { val: "P", nama: "Perempuan" },
      ],

      tabData: [
        {
          text: "Data Personal",
          template: "t1",
          disabled: false,
        },
        {
          text: "Data PPH",
          template: "t2",
          disabled: true,
        },
        {
          text: "Riwayat Pekerjaan",
          template: "t3",
          disabled: true,
        },
      ],
      birthDate: new Date(1981, 5, 3),
      stylingMode: "underlined",

      //outlined, filled, underlined
      labelMode: "floating",
      text: "Olivia loves to sell. She has been selling DevAV products since 2012.",
      positions: service.getPositions(),
      states: service.getStates(),
      phoneRules: {
        X: /[02-9]/,
      },
      dewasDataSource: {
        nama: null,
        tempat_lahir: null,
        tgl_lahir: null,
        telp: null,
        alamat: null,
        agama_id: null,
        jenis_kelamin: null,
        is_dewas: true,
        created_by_user_id: null,
      },

      pegawai_foto: null,
      pegawai_foto_non_binary: null,
      statusSource: [
        { val: true, nama: "Aktif" },
        { val: false, nama: "Tidak Aktif" },
      ],

      statusTertanggungSource: [
        { val: true, nama: "Tertanggung" },
        { val: false, nama: "" },
      ],
      focusedRowKeyKeluarga: 0,
      allowSaving: false,
      statusPenyesuaianSource: [
        { val: true, nama: "Penyesuaian" },
        { val: false, nama: "" },
      ],
      tipeKpSource: [
        { val: "Reguler" },
        { val: "Penyesuaian" },
        { val: "Pilihan" },
      ],
    };
  },

  async created() {
    await this.commonStore.preloadStores();
  },

  async mounted() {},

  methods: {
    can,

    formatDateDisplay(dateOri) {
      if (!dateOri) return "";
      const date = DateTime.fromJSDate(new Date(dateOri));
      return date.toFormat("dd/MM/yyyy");
    },
    formatCheckbox(data, val, valFalse = null) {
      if (data.value) return val;
      else if (valFalse != null) return valFalse;
    },

    validateOnlyOneStatusAktif(e) {
      const countStatusFromDS = _.size(
        _.filter(e.component.getDataSource().items(), { status: true })
      );
      let countStatusFromChanges = 0;

      if (
        e.changes[0] &&
        typeof e.changes[0].data === "object" &&
        "status" in e.changes[0].data
      ) {
        if (e.changes[0].data.status) countStatusFromChanges = 1;
      }

      const totalAktif =
        parseInt(countStatusFromChanges) + parseInt(countStatusFromDS);
      if (totalAktif > 1) return false; //TODO: artinya ada lebih dari 1 aktif
      return true;
    },

    handleFileUploader(e) {
      this.pegawai_foto = e.value[0];
      this.pegawai_foto_non_binary = e.value[0];
      let reader = new FileReader();
      reader.onloadend = () => {
        this.imagePreviewUrl = reader.result;
      };
      reader.readAsDataURL(this.pegawai_foto);
    },

    prevClick(tabSelected) {
      this.tabPanelIndex = _.parseInt(tabSelected);
    },

    validateClick(tabSelected, e) {
      const result = e.validationGroup.validate();

      if (result.isValid) {
        // notify("The task was saved successfully.", "success");
        //enable next step
        // const nextTab = _.parseInt(_.nth(tabSelected, 1));
        const match = tabSelected.match(/t(\d+)/); // Match "t" followed by digits
        const nextTab = match ? parseInt(match[1], 10) : null;
        this.tabPanelIndex = nextTab;
        // this.pegawais.tgl_lahir = formatDateISO(this.pegawais.tgl_lahir);
        if (nextTab < _.size(this.tabData)) {
          this.tabData[nextTab]["disabled"] = false;
        }

        if (nextTab >= _.size(this.tabData)) {
          //ini tab terakhir

          if (this.validAllTabs()) {
            this.postDatabase();
          }
        }
        // this.$refs.myTabPanel.selectedIndex = nextTab;
      } else {
        notify(
          "The task was not saved. Please check if all fields are valid.",
          "error"
        );
      }
    },

    validAllTabs() {
      if (this.pekerjaanDataSource.items().length == 0) {
        notify("Data  Pekerjaan tidak boleh kosong", "error");
        return false;
      }

      return true;
    },

    async postDatabase() {
      this.dewasDataSource.tgl_lahir = this.isDateValid(
        this.dewasDataSource.tgl_lahir
      );
      this.dewasDataSource.created_by_user_id = auth.getUser().id;

      _.forEach(this.pphDataSource.items(), (row) => {
        row.tgl = this.isDateValid(row.tgl);
        row.created_by_user_id = auth.getUser().id;
      });

      _.forEach(this.pekerjaanDataSource.items(), (row) => {
        row.tgl_mulai_bekerja = this.isDateValid(row.tgl_mulai_bekerja);
        row.tgl_akhir_bekerja = this.isDateValid(row.tgl_akhir_bekerja);
        row.created_by_user_id = auth.getUser().id;
      });

      const config = {
        headers: {
          // "content-type": "application/json",
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "multipart/form-data",
        },
      };
      // const self = this;

      try {
        const response = await axios.post(
          `${API_BASE_URL}/dewas/store`,
          {
            dewas: this.dewasDataSource,
            pphs: this.pphDataSource.items(),
            riwayatPekerjaans: this.pekerjaanDataSource.items(),
            file_path: this.pegawai_foto_non_binary,
          },
          config
        );

        if (response.data.status) {
          notify("Data berhasil ditambahkan.", "success");
          const url = this.$router.resolve({
            name: "dewas-detail",
            query: { id: response.data.id },
          }).href;
          window.location.href = url;
        } else notify("Data gagal ditambahkan.", "error");
      } catch (error) {
        // Handle the error appropriately
        console.error("Error:", error);
        notify("Data gagal ditambahkan.", "error");
        return false; // If there was an error
      }
    },

    isDateValid(dateOri) {
      if (!dateOri) {
        return dateOri;
      }
      if (dateOri instanceof Date) {
        // If it's a Date object, format it directly

        const luxonDate = DateTime.fromJSDate(dateOri);
        return luxonDate.toFormat("yyyy-MM-dd");
      }
      var format = "yyyy-MM-dd";
      const date = DateTime.fromFormat(dateOri, format);
      if (date.isValid && date.toFormat(format) === dateOri) {
        return dateOri;
      }

      const parsedDate = DateTime.fromFormat(dateOri, "dd/MM/yyyy");

      // Format the parsed date in the desired format "yyyy-MM-dd"
      return parsedDate.toFormat("yyyy-MM-dd");
    },
  },
};
</script>
<style>
.title {
  padding: 20px 0 20px 0;
  font-size: 18px;
  font-weight: 500;
}

.editors {
  /* margin-right: 320px; */
  height: 570px;
  width: 100%;
}

.editors .left {
  padding: 0 10px 0 0;
}

.editors .right {
  padding: 0 0 0 10px;
}

.editors .left,
.editors .right {
  flex-grow: 1;
}

.editors .left > *,
.editors .right > *,
.editors .center > * {
  margin-bottom: 20px;
}

.editors .center {
  padding: 0 27px 0 0;
}

.validate {
  float: right;
}

.options {
  padding: 20px;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 260px;
  top: 0;
  background-color: rgba(191, 191, 191, 0.15);
}

.caption {
  font-size: 18px;
  font-weight: 500;
}

.option {
  margin-top: 20px;
}

.editors-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 27px;
}
</style>
